// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"4ac574fe","157":"cdaf600d","324":"671905ca","395":"80d847a0","447":"cb7b3b0e","488":"47a79495","623":"70ade12b","659":"7b9664ff","707":"e01e5ad8","744":"7ff330e6","925":"5d00d85c"}[chunkId] + ".chunk.js";
};